import React, { useEffect, useState } from "react";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import { useNavigate } from "react-router-dom";
import ShortQuestionMarking from "../../../components/AssignmentMarking/ShortQuestionMarking";
import ComprehensiveMarking from "../../../components/AssignmentMarking/ComprehensiveMarking";
import { getStudentSubmittedAssignmentAPI } from "../../../redux/features/courseSlice";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import AdminNotification from "../../../components/Notification/AdminNotification";
import InstructorNotification from "../../../components/Notification/InstructorNotification";
import MultipleChoiceView from "../../../components/MultipleChoiceView/MultipleChoiceView";

const AssignmentMarking = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [allData, setAllData] = useState({});

  const auth = useSelector((state) => state.auth);

  const goBack = () => {
    navigate(-1);
  };

  const getFetchCall = async () => {
    try {
      const res = await dispatch(
        getStudentSubmittedAssignmentAPI({
          token: auth.token,
          id: searchParams.get("assignment_id"),
          course_id: searchParams.get("course_id"),
          student_id: searchParams.get("student_id"),
        })
      ).unwrap();
      if (res.success) {
        setAllData(res.data);
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    getFetchCall();
  }, []);

  return (
    <>
      {/* Topbar */}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3
            className="ah-heading-04 fw-bold black-800 me-29 mb-0 d-flex align-items-center gap-3 cursor-pointer"
            onClick={goBack}
          >
            <span className="icon-arrow-left"></span>Assignmnet
          </h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            {auth.role === "Admin" ? (
              <AdminNotification />
            ) : auth.role === "Instructor" ? (
              <InstructorNotification />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      {/* Render Component With Your Requirements */}
      {allData?.type === "multiple_choice" ? (
        <MultipleChoiceView allData={allData} />
      ) : allData?.type === "short_answer" ? (
        <ShortQuestionMarking data={allData} />
      ) : allData?.type === "comprehensive" ? (
        <ComprehensiveMarking data={allData} />
      ) : (
        ""
      )}
    </>
  );
};

export default AssignmentMarking;
